// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3Nv5g","field":"Form_field__dN5m8","pdanger":"Form_pdanger__3HlZG","images":"Form_images__3D8Zs"};